<typography *ngIf="!value" look="inputPlaceholder">{{ placeholder }}</typography>

<typography *ngIf="value"> {{ value.toString() | imask: mask }} </typography>
